import Link from 'next/link';
import React from 'react';

export interface LinkProps {
  children: React.ReactNode;
  to: string;
  variant?: 'primary' | 'secondary';
  size?: 'regular' | 'small';
  className?: string;
  openInNewTab?: boolean;
  includeIosDoubleTapFix?: boolean;
  isExternalLink?: boolean;
  onClickHandler?: () => void;
}

const LinkButton = ({
  children,
  to,
  variant,
  size,
  className,
  openInNewTab,
  includeIosDoubleTapFix, // This is a hack to fix a bug in iOS where the link doesn't work on the first tap. Bug appears on startpage in the main banner slider when you click the CTA button. Found in Safari @ iOS 16.1.2.
  isExternalLink,
  onClickHandler,
}: LinkProps) => {
  const target = openInNewTab
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};

  const fireEventOnTouchStart = includeIosDoubleTapFix
    ? {
      onTouchStart: (e: React.TouchEvent) => {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.dispatchEvent(new MouseEvent('click'));
      },
    }
    : {};

  const classNames = () => {
    let classNames =
      'inline-block text-brand-grey-4 focus-within:outline !no-underline focus-within:outline-offset-3 focus-within:outline-3 focus-within:outline-text-light';

    if (variant === 'primary' || variant === undefined) {
      classNames +=
        ' rounded-full bg-accent-primary-normal lg:hover:bg-accent-primary-dark active:bg-brand-yellow-3';
    } else if (variant === 'secondary') {
      classNames +=
        ' rounded-full bg-neutral-grey-100 lg:hover:bg-neutral-grey-200 active:bg-neutral-grey-300';
    }

    if (size === 'regular' || size === undefined) {
      classNames += ' px-6 py-3.5 text-buttonlabell';
    } else if (size === 'small') {
      classNames += ' px-5 py-2.5 text-buttonlabelm';
    }

    return classNames;
  };
  return isExternalLink ? (
    <a
      href={to}
      className={`${classNames()} ${className}`}
      {...target}
      {...fireEventOnTouchStart}
      tabIndex={0}
      onClick={onClickHandler}
    >
      {children}
    </a>
  ) : (
    <Link
      href={to}
      className={`${classNames()} ${className}`}
      {...target}
      {...fireEventOnTouchStart}
      tabIndex={0}
      onClick={onClickHandler}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
